module.exports = __webpack_public_path__ + "24b03f13eed4903f592b0da50fbc4227.glb";